/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type ResumeJourneyMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ResumeJourneyMutation = {
  __typename?: 'Mutation';
  onboardingResumeJourney?: {
    __typename?: 'OnboardingJourneyType';
    resumable: boolean;
  } | null;
};

export const ResumeJourneyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResumeJourney' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onboardingResumeJourney' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resumable' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeJourneyMutation,
  ResumeJourneyMutationVariables
>;
